import { get, put, post, remove } from './api.service'

const OrganisationService = {
	createOrganisation(params: any) {
		return post('/organisations', params)
	},

	updateOrganisation(organisationId: string, params: any) {
		return put(`/organisations/${organisationId}`, params)
	},

	getOrganisations(params: any) {
		return get('/organisations', params)
	},

	updateOrganisationUsers(organisationId: string, params: any) {
		return put(`/organisations/${organisationId}/users`, params)
	},

	deleteOrganisation(organisationId: string) {
		return remove(`/organisations/${organisationId}`)
	},

	updateOrganisationState(organisationId: string, params: any) {
		return put(`/organisations/${organisationId}/state`, params)
	},

	getOrganisationBySlug(slug: string) {
		return get(`/organisations/${slug}`)
	},

	// API communication

	getAllOrganisationKeys(organisationId) {
		return get(`/organisations/${organisationId}/api-keys`)
	},

	createOrganisationApiKey(
		organisationId: string,
		params: {
			origin_urls: string[]
		}
	) {
		return post(`/organisations/${organisationId}/api-keys`, params)
	},

	deleteOrganisationApiKey(organisationId, apiKeyId) {
		return remove(`/organisations/${organisationId}/api-keys/${apiKeyId}`)
	},

	updateOrganisationApiKey(organisationId, apiKeyId, newOriginUrls: string[]) {
		return put(`/organisations/${organisationId}/api-keys/${apiKeyId}`, {
			origin_urls: newOriginUrls,
			regenerate_key: false,
		})
	},
}

export default OrganisationService
